import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useEffect} from 'react';
import {LoaderFullScreen} from '@features/ui/components/LoaderFullScreen';
import {z} from 'zod';

export const Route = createFileRoute('/flow/')({
  component: FlowPage,
  validateSearch(search) {
    return z
      .object({
        view: z
          .enum([
            'home',
            'projects',
            'tutorials',
            'inspiration',
            'team',
            'changelog',
          ])
          .default('home'),
        newUser: z.boolean().optional(),
        platform: z.string().optional(),
      })
      .parse(search);
  },
});

const viewToRoute = {
  home: '/',
  projects: '/projects',
  tutorials: '/tutorials',
  inspiration: '/inspiration',
  team: '/team',
  changelog: '/whats-new',
};

function FlowPage() {
  const navigate = useNavigate();
  const {newUser, view, platform} = Route.useSearch();

  useEffect(() => {
    const route = viewToRoute[view];
    void navigate({
      to: route,
      search: {
        newUser,
        platform,
      },
    });
  }, [navigate, view, newUser, platform]);

  return <LoaderFullScreen />;
}
